module.exports = __webpack_public_path__ + "static/media/voiture_02_thumb.f7ee682b.png";